import { MANAGEMENT_API_BASE } from 'config'

import { createFetcher } from './createFetcher'

const fetcher = createFetcher({
  baseURL: MANAGEMENT_API_BASE,
})
export default fetcher
